/* A complete HTML document the SERVER composed — an email, an invoice page —
 * shown inside this application without becoming part of it.
 *
 * Two things follow from what such a document is, and both are load-bearing:
 *
 *   · It is not this application's markup and must never join this
 *     application's DOM. Its styles would leak into the page around it, and its
 *     content is document text rather than UI this codebase wrote. So it goes
 *     in through `srcDoc`, never `dangerouslySetInnerHTML`.
 *   · It is composed from text people type — a client's name, a plate, a
 *     location, a note — and a status email's stored copy is served to the
 *     readers of its case (a consolidated one only to those who reach every
 *     case it covered). The frame's `sandbox` is therefore EMPTY: no scripts,
 *     no forms, no same-origin, no top navigation. Nothing in these templates
 *     needs a script to render, and any one `allow-*` token re-opens what the
 *     empty attribute closes (`EmailFrame.test.tsx` pins it).
 *
 * The height is FIXED and the document scrolls inside it, so a fifty-shipment
 * email does not push the sheet's own controls off the screen. A hairline
 * border and no shadow, like every other framed surface. */

export function EmailFrame({
  html,
  title,
  height = '28rem',
}: {
  html: string
  /** Names the frame for assistive technology; without one a frame is
   *  announced as "frame", which says nothing about what is inside it. */
  title: string
  /** Any CSS length. The invoice page asks for most of the viewport, the
   *  status email for a box under the fields that change it. */
  height?: string
}) {
  return (
    <div className="border-line overflow-hidden rounded-[var(--radius-DEFAULT)] border bg-white">
      <iframe
        title={title}
        srcDoc={html}
        // Empty sandbox: every permission withheld. See the note above.
        sandbox=""
        style={{ height }}
        className="block w-full border-0 bg-white"
      />
    </div>
  )
}
